import { fg } from '@atlaskit/platform-feature-flags';

import { ProductKeys3P, type ProductKeys } from '../../../../constants/products';

export const getFederatedEmailResultCountLimit = ({
	productKey,
	count,
	hasMoreGmailResults,
}: {
	productKey: ProductKeys;
	count?: number;
	hasMoreGmailResults?: boolean;
}): number | undefined => {
	if (productKey !== ProductKeys3P.Gmail || !fg('formula_3p_gmail_result_count')) {
		return undefined;
	}

	if (!hasMoreGmailResults || count === undefined) {
		return undefined;
	}

	return count;
};
